import React, { useState } from 'react';
import StockIssue from '../components/StockIssue';
import StockReceive from '../components/StockReceive';
import StockAdjust from '../components/StockAdjust';
import StockReserve from '../components/StockReserve';
import StockRelease from '../components/StockRelease';
import StockList from '../components/StockList';
import Modal from '../components/Modal';
import { useNavigate } from 'react-router-dom';
import QrScan from '../components/QrScan';
import QrGenerator from './QrGenerator';
import ScanHistory from '../components/ScanHistoryList';
import GpsTracker from '../components/GpsTracker';
import LowStockList from '../components/LowStockList';
import MultiQrPdf from '../components/MultiQrPdf';


const StockPage: React.FC = () => {

    const navigate = useNavigate();

    const [modal, setModal] = useState<null | 'lowstock' | 'qrscan' | 'qrgenerator' | 'multiqrpdf' | 'scanhistory' | 'reserve' | 'release' | 'receive' | 'issue' | 'adjust'>(null);

    return (
        <div className="container mx-auto p-1 pb-14">

            <div className="stock-navgrid fixed top-10 left-0  grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-8 mt-8 p-2 pb-16 border-r-2 border-gray-200 bg-white shadow-lg z-10">
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">Stock List</h2>
                    <button onClick={() => navigate('/stock-management')} className="mb-1 px-2 py-1 bg-teal-600 text-white rounded hover:bg-teal-700">Go to</button>
                </div>
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">Low Stock</h2><button onClick={() => setModal('lowstock')} className="mb-1 px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700">Open</button>

                </div>
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">QR Scan</h2>
                    <button onClick={() => setModal('qrscan')} className="mb-1 px-2 py-1 bg-purple-600 text-white rounded hover:bg-purple-700">Open</button>
                </div>
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">QR Generate</h2>
                    <button onClick={() => setModal('qrgenerator')} className="mb-1 px-2 py-1 bg-slate-600 text-white rounded hover:bg-slate-700">Open</button>
                </div>
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">Multi QR PDF</h2>
                    <button onClick={() => setModal('multiqrpdf')} className="mb-1 px-2 py-1 bg-slate-400 text-white rounded hover:bg-slate-500">Open</button>
                </div>
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">Scan History</h2>
                    <button onClick={() => setModal('scanhistory')} className="mb-1 px-2 py-1 bg-amber-600 text-white rounded hover:bg-amber-700">Open</button>
                </div>
                {/* <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">Stock Reserve</h2>
                    <button onClick={() => setModal('reserve')} className="mb-1 px-2 py-1 bg-amber-600 text-white rounded hover:bg-amber-700">Open</button>
                </div>
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">Stock Release</h2>
                    <button onClick={() => setModal('release')} className="mb-1 px-2 py-1 bg-red-600 text-white rounded hover:bg-red-700">Open</button>
                </div>
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">Stock Receive</h2>
                    <button onClick={() => setModal('receive')} className="mb-1 px-2 py-1 bg-green-600 text-white rounded hover:bg-green-700">Open</button>
                </div>
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">Stock Issue</h2>
                    <button onClick={() => setModal('issue')} className="mb-1 px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700">Open</button>
                </div>
                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center">Stock Adjustment</h2>
                    <button onClick={() => setModal('adjust')} className="mb-1 px-2 py-1 bg-yellow-600 text-white rounded hover:bg-yellow-700">Open</button>
                </div> */}
            </div>

            {/* <h1 className="text-xl font-bold mb-2 text-center">Stock Management</h1> */}

            <div className="w-auto max-w-xl md:max-w-7xl mx-auto ml-24 md:ml-14 md:mr-8  mb-4">
                <StockList />
            </div>



            <div className="stock-modal-container ">
                <Modal isOpen={modal === 'lowstock'} onClose={() => setModal(null)} title="Low Stock Item List">
                    <LowStockList />
                </Modal>
                <Modal isOpen={modal === 'qrscan'} onClose={() => setModal(null)} title="QR Scanner">
                    <QrScan />
                </Modal>
                <Modal isOpen={modal === 'qrgenerator'} onClose={() => setModal(null)} title="QR Generator">
                    <QrGenerator />
                </Modal>
                <Modal isOpen={modal === 'multiqrpdf'} onClose={() => setModal(null)} title="Multi QR PDF">
                    <MultiQrPdf />
                </Modal>
                <Modal isOpen={modal === 'scanhistory'} onClose={() => setModal(null)} title="Scan History">
                    <ScanHistory />
                </Modal>
                <Modal isOpen={modal === 'reserve'} onClose={() => setModal(null)} title="Stock Reserve">
                    <StockReserve />
                </Modal>
                <Modal isOpen={modal === 'release'} onClose={() => setModal(null)} title="Stock Release">
                    <StockRelease />
                </Modal>
                <Modal isOpen={modal === 'receive'} onClose={() => setModal(null)} title="Stock Receive">
                    <StockReceive />
                </Modal>
                <Modal isOpen={modal === 'issue'} onClose={() => setModal(null)} title="Stock Issue">
                    <StockIssue />
                </Modal>
                <Modal isOpen={modal === 'adjust'} onClose={() => setModal(null)} title="Stock Adjustment">
                    <StockAdjust />
                </Modal>
            </div>

        </div>
    );
};

export default StockPage;
